
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserPlus } from "lucide-react";

interface UsernameFieldProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  placeholder: string;
  isDisabled?: boolean;
}

export const UsernameField = ({ 
  value, 
  onChange, 
  label, 
  placeholder,
  isDisabled = false 
}: UsernameFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="username" className="text-sm font-medium flex items-center gap-2">
        <UserPlus className="h-4 w-4 text-primary" />
        {label}
      </Label>
      <Input
        id="username"
        type="text"
        value={value}
        onChange={onChange}
        required
        placeholder={placeholder}
        className="border-input shadow-sm focus:border-primary/30 focus:ring-primary/20"
        disabled={isDisabled}
      />
    </div>
  );
};
